import api from './api'

async function searchPatients (query = '', { page = 1, signal } = {}) {
  const url = query ? `/patients/${page}/${encodeURIComponent(query)}` : `/patients/${page}`
  const result = await api.get(url, { signal })
  return result.data.data
}

export { searchPatients }
